import { Component } from "react";

/**
 * Affiche une page de repli si une erreur React non gérée casse l’arbre (évite l’écran blanc total).
 */
export class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error("[AppErrorBoundary]", error, errorInfo?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    const msg = error?.message || String(error);

    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 px-6 py-12 text-center">
        <h1 className="font-display text-xl font-bold text-slate-900">Une erreur a interrompu l’affichage</h1>
        <p className="max-w-md text-sm leading-relaxed text-slate-600">
          Vous pouvez recharger la page. Si le problème continue, ouvrez la console du navigateur (F12) et copiez le message
          d’erreur pour le support.
        </p>
        <p className="max-w-lg rounded-lg border border-red-200 bg-red-50 px-3 py-2 font-mono text-xs text-red-900 break-words">
          {msg}
        </p>
        <button
          type="button"
          className="rounded-xl bg-[#2D7FF9] px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[#1f6fe8]"
          onClick={() => window.location.reload()}
        >
          Recharger
        </button>
      </div>
    );
  }
}
